/* Inklapbare statistieken/tools-sectie boven de Unified Inbox.
 * Standaard INGEKLAPT zodat de berichten meteen zichtbaar zijn zonder
 * scrollen; de keuze wordt onthouden in localStorage. */
import React, { useState } from "react";
import i18n from "i18next";
import { BarChart3, ChevronDown } from "lucide-react";

const LS_KEY = "jr.inbox.stats.open";

export default function CollapsibleStats({ children }) {
    const [open, setOpen] = useState(() => localStorage.getItem(LS_KEY) === "1");
    const toggle = () => setOpen((o) => {
        localStorage.setItem(LS_KEY, o ? "0" : "1");
        return !o;
    });
    return (
        <div className="mb-4">
            <button onClick={toggle} data-testid="inbox-stats-toggle" aria-expanded={open}
                className="w-full flex items-center gap-3 rounded-xl border border-white/10 bg-[var(--jr-surface)] px-5 py-3 hover:bg-white/[0.03] transition-colors">
                <BarChart3 size={14} className="text-[var(--jr-brand)]" />
                <span className="text-[11px] font-mono uppercase tracking-[0.2em] text-[var(--jr-text-2)]">{i18n.t("inbox.stats_title")}</span>
                <span className="ml-auto text-[10px] font-mono uppercase tracking-[0.16em] text-[var(--jr-text-3)]">
                    {open ? i18n.t("inbox.stats_hide") : i18n.t("inbox.stats_show")}
                </span>
                <ChevronDown size={14} className={`text-[var(--jr-text-3)] transition-transform ${open ? "rotate-180" : ""}`} />
            </button>
            {open && <div className="mt-4" data-testid="inbox-stats-body">{children}</div>}
        </div>
    );
}
